<template>
  <div class="renewing-membership membership-options confirm-electoral step-3-wrapper">
    <el-row :gutter="40">
      <el-col :md="12" class="receipt-box">
        <h6 class="receipt-title">Your Payment Confirmation</h6>
        <div class="info-box">
          <h6 class="receipt-info bold" v-for="person in members" :key="person.id">{{ person.fullName }}</h6>
          <h6 class="receipt-info">{{ fullAddress }}</h6>
        </div>
        <div class="info-box" v-if="receipt.last_4_card">
          <h6 class="receipt-info bold">Credit Card</h6>
          <h6 class="receipt-info">ending in {{ receipt.last_4_card }}</h6>
        </div>
        <div class="info-box">
          <h6 class="receipt-info bold">Thank you, your payment has been processed.</h6>
          <h6 class="receipt-info">Total Payment of ${{ receipt.amount_paid }}</h6>
          <h6 class="receipt-info">Receipt Number: {{ receipt.reference_number }}</h6>
        </div>
      </el-col>
      <el-col :md="12">
        <div v-html="rightDescription"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  computed: {
    ...mapState('renewal', ['receipt']),
    ...mapGetters('renewal', ['members', 'configOptions', 'donorInformation']),
    fullName() {
      return `${this.donorInformation.prefix} ${this.donorInformation.first_name} ${this.donorInformation.last_name}`;
    },
    fullAddress() {
      const { address_1, suburb, state, post_code } = this.donorInformation.address;
      return `${address_1}, ${suburb} ${state} ${post_code}`;
    },
    rightDescription() {
      return this.members.length > 1 ? this.configOptions['renewal-confirmation-jnt'] : this.configOptions['renewal-confirmation-ind'];
    }
  },
}
</script>

<style lang="scss" scoped>
.receipt-box {
  padding: 12px;

  @media (max-width: 500px) {
    margin-bottom: 40px;
  }
}

.info-box {
  padding: 18px;
  margin-bottom: 15px;

  &:last-of-type {
    margin-bottom: 10px;
  }
}

.receipt-box, .info-box {
  border: 1px solid rgba(22,30,46,0.16);
  box-sizing: border-box;
  border-radius: 4px;
}

@media (max-width: 500px) {
  .el-row {
    margin-left: 0!important;
    margin-right: 0!important;
  }
}
</style>
